module.exports = __webpack_public_path__ + "static/media/credit-card-front.94ceb266.svg";